export default {"src":"/_next/static/media/fantom.36fc491e.svg","height":128,"width":493,"blurWidth":0,"blurHeight":0};